import React, { useState } from "react";
import styles from './newthree.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ActiveDot from '../../../src/assets/images/icon/icongreendot.svg'
import { faDownload, faEye, faFilter, faPencil, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ModalWindow from "../../old_Components/Common/ModalWindow1";

const Newthree = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  return (
    <div>
      {showModal && (
        <ModalWindow
          title="Add New User"
          toggleModal={toggleModal}
          className="custom-modal-class"
        >
          <form>
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="fullName" className={`${styles['form-labelctm']} form-label`}>
                Full name <span className="text-danger">*</span>
                </label>
                <input type="text" className={`${styles['form-controlctm']} form-control`} id="fullName" placeholder="Enter full name" />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="email" className={`${styles['form-labelctm']} form-label`}>
                  Employee Email ID <span className="text-danger">*</span>
                </label>
                <input type="email" className={`${styles['form-controlctm']} form-control`} id="email" placeholder="Enter email id" />
              </div>
              <div className="col-md-6">
                <label htmlFor="phoneNumber" className={`${styles['form-labelctm']} form-label`}>
                  Phone Number <span className="text-danger">*</span>
                </label>
                <input type="tel" className={`${styles['form-controlctm']} form-control`} id="phoneNumber" placeholder="Enter phone number" />
              </div>
            </div>
            <div className="row mb-3">

              <div className="col-md-6">
                <label htmlFor="username" className={`${styles['form-labelctm']} form-label`}>
                  Create Username <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input type="text" className={`${styles['form-controlctm']} form-control`} id="username" placeholder="Create Username" />

                </div>
              </div>

              <div className="col-md-6">
                <label htmlFor="password" className={`${styles['form-labelctm']} form-label`}>
                  Create password <span className="text-danger">*</span>
                </label>
                <div className="input-group position-relative">
                  <input type="password" className={`${styles['form-controlctm']} form-control`} id="password" placeholder="Create temporary password" />
                  <a href="#" className={`${styles['eye-link']}`}><FontAwesomeIcon icon={faEye} /></a>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <label className={`${styles['form-labelctm']} form-label`}>Status <span className="text-danger">*</span></label>
              <div className="d-flex">
                <div className="form-check d-flex align-items-center me-3">
                  <input className="form-check-input" type="radio" name="status" id="active" value="Active" defaultChecked />
                  <label className="form-check-label ps-2" htmlFor="active">
                    Active
                  </label>
                </div>
                <div className="form-check d-flex align-items-center me-3">
                  <input className="form-check-input" type="radio" name="status" id="inactive" value="Inactive" />
                  <label className="form-check-label ps-2" htmlFor="inactive">
                    Inactive
                  </label>
                </div>
                <div className="form-check d-flex align-items-center">
                  <input className="form-check-input" type="radio" name="status" id="suspended" value="Suspended" />
                  <label className="form-check-label ps-2" htmlFor="suspended">
                    Suspended
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div className="d-flex justify-content-end">
              <button type="button" className={`${styles['cancel-btn']} btn me-2`}>
                Cancel
              </button>
              <button type="submit" className={`${styles['add-btn']} btn`}>
                Add New User
              </button>
            </div>
          </form>
        </ModalWindow>
      )}
      <div className="container">
        <div className='row'>
          <div className='col-md-12'>
            <div className={`${styles['manage-box']}`}>
              <div className="d-flex justify-content-between align-items-center mb-3 px-3">
                <h4 className={`${styles['user-title']}`}>Users</h4>
                <div>
                  <a href='#' className={`${styles['filter-link']} pe-3`}><FontAwesomeIcon icon={faFilter} /></a>
                  <a href='#' className={`${styles['download-link']} pe-3`}><FontAwesomeIcon icon={faDownload} /></a>
                  <a href='#' className={`${styles['delete-link']} pe-3`}><FontAwesomeIcon icon={faTrash} /></a>
                  <button onClick={handleShow} className={`${styles['add-btn']} btn`}>+ Add User</button>

                </div>
              </div>
              <div className='table-responsive'>
                <table className="table table-striped table-responsive table-hover">
                  <thead className="table-light">
                    <tr className={`${styles['tablectm-head']}`}>
                      <th scope="col"><input type="checkbox" /></th>
                      <th scope="col">Full Name</th>
                      <th scope="col">Employee Email ID</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Username</th>
                      <th scope="col">Password</th>
                      <th scope="col">Status</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody className={`${styles['tablectm-text']}`}>
                    {[...Array(10)].map((_, index) => (
                      <tr key={index}>
                        <td><input type="checkbox" /></td>
                        <td>
                          <img
                            src={`https://via.placeholder.com/40`} // Replace with user profile image URLs
                            alt="user-profile"
                            className="rounded-circle me-2"
                            width="40"
                          />
                          <span>User Name {index + 1}</span>
                        </td>
                        <td>user{index + 1}@example.com</td>
                        <td>+91-1234567890</td>
                        <td>username{index + 1}</td>
                        <td>********</td>
                        <td>
                          <span className={`${styles['active-badge']}`}><img src={ActiveDot} className='pe-2' />Active</span>
                        </td>
                        <td>
                          <a className={`${styles['link-ctm']} me-4`}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </a>
                          <a className={`${styles['link-ctm']}`}>
                            <FontAwesomeIcon icon={faPencil} />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Newthree